// extracted by mini-css-extract-plugin
export default {"infoPaper":"style_infoPaper__nkyi0","wrapper":"style_wrapper__web5e","backgroundWrapper":"style_backgroundWrapper__QeVOt"};